import React from 'react'
import Header from './include/Header'
import Footer from './include/Footer'
import WhatsAppChat from './include/WhatsAppChat'

function Base({ children }) {

    return (
        <>
            <Header />
            {children}
            <Footer />
            <WhatsAppChat />

        </>
    )
}

export default Base
